import { render } from "./InactivarCodigosCSV.vue?vue&type=template&id=cde2ba70&scoped=true"
import script from "./InactivarCodigosCSV.vue?vue&type=script&lang=js"
export * from "./InactivarCodigosCSV.vue?vue&type=script&lang=js"

import "./InactivarCodigosCSV.vue?vue&type=style&index=0&id=cde2ba70&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde2ba70"]])

export default __exports__